




import { Component, Prop, Vue } from 'vue-property-decorator'
import { Question } from '@/store/modules/survey-store-module'

@Component
export default class DescriptionQuestion extends Vue {
  @Prop({ required: true }) question!: Question
}
